// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"1092":"928cbd28","4849":"efc4d37a","5864":"0b08488c"}[chunkId] + ".chunk.css";
};